import React, { useEffect, useRef } from 'react';

const TableWrapper = ({ children }) => {
  const wrapperRef = useRef(null);

  useEffect(() => {
    // Suppress ResizeObserver errors
    const errorHandler = (event) => {
      if (event.message && event.message.includes('ResizeObserver')) {
        event.stopPropagation();
        event.preventDefault();
      }
    };

    window.addEventListener('error', errorHandler);
    window.addEventListener('unhandledrejection', errorHandler);

    return () => {
      window.removeEventListener('error', errorHandler);
      window.removeEventListener('unhandledrejection', errorHandler);
    };
  }, []);

  return (
    <div 
      ref={wrapperRef} 
      style={{ 
        width: '100%', 
        position: 'relative',
        contain: 'paint layout',
      }}
    >
      {children}
    </div>
  );
};

export default TableWrapper;
